import axios from "axios";
import httpTools from "./httpTools";
import store from "Store";

const Drawers = (() => {
    const baseUrl = httpTools.envUrls(true);

    async function getFaq(country, language) {
        try {
            const response = await axios.get(`${baseUrl}/drawers/${country}%20FAQ`, {
                headers: {
                    "Accept-Language": `${language}-${country}`
                }
            });

            return response;
        } catch (error) {
            return error;
        }
    }

    return {
        getDrawers: async () => {
            const locale = store.getState().locale;

            let faq = await getFaq(locale.country, locale.language);

            if (faq.status === 200) {
                return { faq, language: locale.language };
            }

            faq = await getFaq("US", locale.language);

            if (faq.status === 200) {
                return { faq, language: locale.language };
            }

            faq = await getFaq("US", "en");

            return { faq, language: "en" };
        }
    };
})();

export default Drawers;



// WEBPACK FOOTER //
// ./src/services/http/drawers.js